module.exports = __webpack_public_path__ + "static/assets/f23c88994d8e5b0d31fa0693d2a26826.png";